import React, { Component } from 'react';
import T from 'i18n-react';
// Composants
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
// Style
import './ProfileDropdown.css';

class ProfileDropdown extends Component {

    /**
     * Action au changement de bu
     * @param {*} event
     * @param {*} index
     * @param {*} value
     */
    onChange = (event, index, value) => {
        // Si on essaye de resélectioner un profile on ne fait rien
        if (this.props.selectedProfile && this.props.selectedProfile === value) {
            return;
        }

        this.props.selectProfile(value);
    };


    render() {
        return (
            <div className="dropdownProfileContainer">
                <span className="dropDownProfileLabel">{this.props.label}</span>
                <DropDownMenu className='dropdownProfile'
                              value={this.props.selectedProfile}
                              onChange={this.onChange}
                              disabled={this.props.disabled}
                              {...this.props.configs}>
                    {Object.keys(this.props.profileMap).map(key =>
                        <MenuItem key={key}
                                  id={key}
                                  value={this.props.profileMap[key]}
                                  primaryText={T.translate(`userProfile.${this.props.profileMap[key]}`)}/>
                    )}
                </DropDownMenu>
            </div>
        );
    }

}

ProfileDropdown.defaultProps = {
    profileMap: {},
    configs: {}
};

export default ProfileDropdown;



// WEBPACK FOOTER //
// ./src/components/ProfileDropdown/ProfileDropdown.js